import {PropsWithChildren} from "react";
import {Toaster} from "@/components/ui/sonner.tsx";

export function Wrapper({children}: PropsWithChildren) {
    return (
        <div className="h-screen w-screen p-16 bg-sky-900/20">
            <div className="rounded-4xl shadow-xl overflow-hidden flex h-[calc(100vh-8rem)] v-[calc(100vw-8rem)] bg-white">
                {children}
            </div>

            <Toaster/>
        </div>
    )
}